var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-drawer',{attrs:{"visible":_vm.drawerMenu,"direction":"ltr","title":"","size":"70%","show-close":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.drawerMenu=$event}}},[_c('ps-lateral-bar',{attrs:{"labels":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }